import { Box } from '@factorialco/deprecated-design-system'
import { DocumentsCustomFieldSettingsDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useQuery } from 'modules/core/hooks/useQuery'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import CustomFields from 'modules/custom_resources/components/CustomFields'
import customFieldsByGroup from 'modules/custom_resources/store/collections/customFields/byGroup'
import CustomField from 'modules/custom_resources/store/models/customFields/Field'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const CustomFieldsSettings = () => {
  const {
    loading: loadingPageQuery,
    data,
    error,
  } = useQuery(DocumentsCustomFieldSettingsDocument, {})

  const canManageCustomFields =
    data?.customFields?._policies?.companyCreateCustomFields?.can || false

  const { loading: loadingCustomFields } = useAsyncData(() => {
    return Promise.all([
      customFieldsByGroup.fetch({
        data: {
          usage_group_slug: [CustomField.UsageGroups.documents, CustomField.UsageGroups.expenses],
        },
      }),
    ])
  }, [])

  const loading = loadingPageQuery || loadingCustomFields

  const createCustomField = (data: Record<string, string | number>) =>
    customFieldsByGroup.createForGroup(CustomField.UsageGroups.documents, data)

  return (
    <ResponsivePage.Body variant="full" loading={loading} error={error} showHeader={false}>
      <Box paddingTop="s32">
        <CustomFields
          allowPermissions
          canEditCustomField={canManageCustomFields && hasFeature('documents_custom_fields')}
          canCreateCustomField={canManageCustomFields && hasFeature('documents_custom_fields')}
          canDeleteCustomField={canManageCustomFields && hasFeature('documents_custom_fields')}
          createCustomField={createCustomField}
          customFields={customFieldsByGroup.models}
          description={i18n.t('settings.folders.custom_fields.description')}
          title={i18n.t('settings.folders.custom_fields.title')}
        />
      </Box>
    </ResponsivePage.Body>
  )
}
export default observer(CustomFieldsSettings)
